import React from 'react';
import '../index.css';

import FooterLogo from '../icons/footerLogo.svg';
import FooterLogoUnder from '../icons/Line95.png';

function FooterApp() {
  return (
    <footer className="App-footer">
      <div
        style={{
          paddingRight: 95,
          paddingLeft: 93,
          display: 'flex',
          flexDirection: 'column',
          margin: '0 auto',
          width: 'max-content',
          backgroundColor: '#dddddd',
        }}
      >
        <img
          alt="footerlogo"
          src={FooterLogo}
          style={{
            paddingTop: 42,
            marginBottom: -1.6,
            width: 149.05,
            height: 32,
          }}
        />
        <img alt="footerlogo_underbar" src={FooterLogoUnder} width={1178} />
        <p
          style={{
            paddingTop: 20,
          }}
        >
          <a
            href="https://dazzling-whale-1af.notion.site/42655ce0a460498c98462887a7921709"
            target="_blank"
            rel="noreferrer"
            style={{
              fontWeight: 600,
              paddingRight: 88,
              fontSize: 16,
              cursor: 'zoom-in',
              color: '#848484',
            }}
          >
            이용약관
          </a>
          <a
            href="https://dazzling-whale-1af.notion.site/588dcdd26baa42b683f344098eab657a"
            target="_blank"
            rel="noreferrer"
            style={{
              fontWeight: 600,
              paddingRight: 88,
              fontSize: 16,
              cursor: 'zoom-in',
              color: '#848484',
            }}
          >
            유료서비스약관
          </a>
          <a
            href="https://dazzling-whale-1af.notion.site/46df0fb9597f4cc598ac9db60707fe1c"
            target="_blank"
            rel="noreferrer"
            style={{
              fontWeight: 600,
              fontSize: 16,
              cursor: 'zoom-in',
              color: '#848484',
            }}
          >
            개인정보처리약관
          </a>
        </p>
        <div>
          <div
            style={{
              paddingTop: 20,
              whiteSpace: 'pre',
            }}
          >
            <span
              style={{
                //fontWeight: 600,
                fontSize: 14,
                color: '#848484',
              }}
            >
              <strong>대표</strong> 이욱재 <strong>| 사업자 등록번호</strong>{' '}
              206-86-57861
            </span>
          </div>
          <div
            style={{
              paddingTop: 8,
              whiteSpace: 'pre',
            }}
          >
            <span
              style={{
                //fontWeight: 600,
                fontSize: 14,
                color: '#848484',
              }}
            >
              <strong>통신판매신고번호</strong> 2019-의정부흥선-0179
            </span>
          </div>
          <div
            style={{
              paddingTop: 8,
              whiteSpace: 'pre',
            }}
          >
            <span
              style={{
                //fontWeight: 600,
                fontSize: 14,
                color: '#848484',
              }}
            >
              <strong>주소</strong> 서울특별시 광진구 긴고랑로14길 64, 지층 (중곡동)
            </span>
          </div>
          <div
            style={{
              paddingTop: 8,
              whiteSpace: 'pre',
              paddingBottom: 50,
            }}
          >
            <span
              style={{
                //fontWeight: 600,
                fontSize: 14,
                color: '#848484',
              }}
            >
              <strong>대표메일</strong> enwise.inc@gmail.com{' '}
              <strong>| 전화번호</strong> 010-6512-8642
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default FooterApp;
